/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DisplayRef,
  DisplayRef$inboundSchema,
  DisplayRef$Outbound,
  DisplayRef$outboundSchema,
} from "./displayref.js";

/**
 * A reference to a sequence.
 */
export type SequenceRef = {
  /**
   * A reading or setting reference that is used to display a value.
   */
  displayRef: DisplayRef;
  /**
   * The key of the sequence.
   */
  key: string;
};

/** @internal */
export const SequenceRef$inboundSchema: z.ZodType<
  SequenceRef,
  z.ZodTypeDef,
  unknown
> = z.object({
  display_ref: DisplayRef$inboundSchema,
  key: types.string(),
}).transform((v) => {
  return remap$(v, {
    "display_ref": "displayRef",
  });
});
/** @internal */
export type SequenceRef$Outbound = {
  display_ref: DisplayRef$Outbound;
  key: string;
};

/** @internal */
export const SequenceRef$outboundSchema: z.ZodType<
  SequenceRef$Outbound,
  z.ZodTypeDef,
  SequenceRef
> = z.object({
  displayRef: DisplayRef$outboundSchema,
  key: z.string(),
}).transform((v) => {
  return remap$(v, {
    displayRef: "display_ref",
  });
});

export function sequenceRefToJSON(sequenceRef: SequenceRef): string {
  return JSON.stringify(SequenceRef$outboundSchema.parse(sequenceRef));
}
export function sequenceRefFromJSON(
  jsonString: string,
): SafeParseResult<SequenceRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SequenceRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SequenceRef' from JSON`,
  );
}
